import type {
  CancelablePromise,
  TGetIncentiveStatementReportingPeriodRequest,
  TGetIncentiveStatementReportingPeriodResponse,
  TGetIncentiveStatementRequest,
  TGetIncentiveStatementResponse,
  TListIncentiveStatementReportingPeriodsRequest,
  TListIncentiveStatementReportingPeriodsResponse,
} from '/src/api';
import { OpenAPI, request as __request } from '/src/api';

export class IncentiveStatementService {
  /**
   * List Incentive Statement Reporting Periods
   * @returns IncentiveStatementReportingPeriod[]
   * @throws ApiError
   */
  public static listIncentiveStatementReportingPeriods({
    client_id,
    ...req
  }: TListIncentiveStatementReportingPeriodsRequest): CancelablePromise<TListIncentiveStatementReportingPeriodsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clients/{client_id}/incentiveStatementReportingPeriods',
      path: { client_id },
      query: req,
    });
  }

  /**
   * Get Incentive Statement Reporting Period (Combined)
   * @returns IncentiveStatement
   * @throws ApiError
   */
  public static getIncentiveStatementReportingPeriod({
    id,
  }: TGetIncentiveStatementReportingPeriodRequest): CancelablePromise<TGetIncentiveStatementReportingPeriodResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/incentiveStatementReportingPeriods/{id}',
      path: { id },
    });
  }

  /**
   * Get Incentive Statement
   * @returns IncentiveStatement
   * @throws ApiError
   */
  public static getIncentiveStatement({
    id,
  }: TGetIncentiveStatementRequest): CancelablePromise<TGetIncentiveStatementResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/incentiveStatements/{id}',
      path: { id },
    });
  }
}
